// import { format } from 'date-fns';
const { format } = require('date-fns');

const activityFactorCodeMap = {
  light: 1,
  moderate: 2,
  intense: 3,
};

// Selecionar o paciente
const selectOptions = (items, labelKey = 'name') => items.map(item => ({
  value: item.person_id,
  label: item[labelKey],
}));
//1. dateUtils.js


const calculateAge = (birthDateStr) => {
  const today = new Date();
  const birthDate = new Date(birthDateStr);

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  if (days < 0) {
    const previousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += previousMonth.getDate();
    months--;
  }

  if (months < 0) {
    months += 12;
    years--;
  }

  return { years, months, days };
};

const calculateGestationalAge = (lastMenstrualDate) => {
  if (!lastMenstrualDate) return null;
  const today = new Date();
  const lmpDate = new Date(lastMenstrualDate);
  if (isNaN(lmpDate.getTime())) return null;

  const diffInMs = today - lmpDate;
  return Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 7)); // in weeks
};

const calculateEstimatedDeliveryDate = (lastMenstrualDate) => {
  if (!lastMenstrualDate) return null;
  const lmpDate = new Date(lastMenstrualDate);
  const edd = new Date(lmpDate.setDate(lmpDate.getDate() + 280)); // 40 weeks
  return format(edd, 'dd/MM/yyyy');
};

const convertDateForDatabase = (formattedDate) => {
  if (!formattedDate) return null;
  const [day, month, year] = formattedDate.trim().split('/');
  if (!day || !month || !year) return null;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

//2. utils/anthropometry/patientUtils.js

const formatPatientGroup = (groupId) => {
  switch (groupId) {
    case '1': return 'Infant';
    case '2': return 'Child';
    case '3': return 'Adult';
    case '4': return 'Elderly';
    case '5': return 'Pregnant';
    case '6': return 'Lactating';
    default: return '';
  }
};


const calculateSkinfoldsSum = (skinfolds, equation) => {
  const {
    triceps = 0,
    suprailiac = 0,
    subscapular = 0,
    chest = 0,
    axillary = 0,
    abdominal = 0,
    thigh = 0,
    calf = 0,
    biceps = 0
  } = skinfolds;

  let sum = 0;

  switch (equation) {
    case '1': // Jackson & Pollock - 3 Skinfolds
      sum = Number(triceps) + Number(suprailiac) + Number(thigh);
      break;
    case '2': // Jackson & Pollock - 7 Skinfolds
      sum = Number(triceps) + Number(subscapular) + Number(chest) +
        Number(axillary) + Number(abdominal) + Number(thigh) + Number(calf);
      break;
    case '3': // Petrosky - 4 Skinfolds
      sum = Number(triceps) + Number(suprailiac) + Number(subscapular) + Number(thigh);
      break;
    case '4': // Durnin & Womersley - 4 Skinfolds
      sum = Number(triceps) + Number(biceps) + Number(subscapular) + Number(suprailiac);
      break;
    default:
      return 0;
  }

  if (isNaN(sum)) return 0;
  return Number(sum).toFixed(2);
};

const calculateBodyFatPercentage = (gender, skinfoldsSum, age, equation) => {
  let density = 0;

  switch (equation) {
    case '1':
      density = gender === 'male'
        ? 1.10938 - (0.0008267 * skinfoldsSum) + (0.0000016 * skinfoldsSum ** 2) - (0.0002574 * age)
        : 1.0994921 - (0.0009929 * skinfoldsSum) + (0.0000023 * skinfoldsSum ** 2) - (0.0001392 * age);
      break;
    case '2':
    case '3':
      density = gender === 'male'
        ? 1.112 - (0.00043499 * skinfoldsSum) + (0.00000055 * skinfoldsSum ** 2) - (0.00028826 * age)
        : 1.097 - (0.00046971 * skinfoldsSum) + (0.00000056 * skinfoldsSum ** 2) - (0.00012828 * age);
      break;
    case '4':
      density = gender === 'male'
        ? 1.17136 - (0.06706 * Math.log10(skinfoldsSum))
        : 1.1665 - (0.07063 * Math.log10(skinfoldsSum));
      break;
    default:
      return 'Undefined';
  }

  const fatPercentage = (495 / density) - 450;
  return fatPercentage.toFixed(2);
};

const calculateIdealBodyFatPercentage = (age, gender) => {
  if (gender === 'male') {
    if (age < 30) return { min: 8, max: 15 };
    if (age < 50) return { min: 11, max: 17 };
    return { min: 12, max: 19 };
  } else {
    if (age < 30) return { min: 15, max: 23 };
    if (age < 50) return { min: 18, max: 25 };
    return { min: 20, max: 28 };
  }
};



//5. classifications.js
const classifyChildBMI = (zScore) => {
  if (zScore > 2) return 'Overweight';
  if (zScore >= -2 && zScore <= 2) return 'Adequate weight';
  if (zScore < -2) return 'Underweight';
  return 'Undetermined';
};

const classifyElderlyBMI = (bmi) => {
  if (bmi < 22) return 'Underweight';
  if (bmi >= 22 && bmi <= 27) return 'Normal';
  if (bmi > 27) return 'Overweight';
  return 'Undetermined';
};

const classifyBMI = (bmi, zScore, patientGroup) => {
  if (patientGroup === '2') {
    return zScore ? classifyChildBMI(zScore) : 'z-Score not provided';
  }

  if (patientGroup === '4') {
    return classifyElderlyBMI(bmi);
  }

  if (bmi < 16) return 'Severe Thinness Grade III';
  if (bmi < 17) return 'Thinness Grade II';
  if (bmi < 18.5) return 'Thinness Grade I';
  if (bmi < 25) return 'Normal';
  if (bmi < 30) return 'Overweight';
  if (bmi < 35) return 'Obesity Grade I';
  if (bmi < 40) return 'Obesity Grade II';
  return 'Obesity Grade III';
};

const classifyMuscleMass = (armMuscleArea, gender) => {
  if (gender === 'male') {
    if (armMuscleArea <= 35) return 'Low muscle mass';
    if (armMuscleArea > 35 && armMuscleArea <= 45) return 'Below average';
    if (armMuscleArea > 45 && armMuscleArea <= 60) return 'Average';
    if (armMuscleArea > 60 && armMuscleArea <= 75) return 'Above average';
    if (armMuscleArea > 75) return 'High muscle mass';
  } else {
    if (armMuscleArea <= 20) return 'Low muscle mass';
    if (armMuscleArea > 20 && armMuscleArea <= 25) return 'Below average';
    if (armMuscleArea > 25 && armMuscleArea <= 35) return 'Average';
    if (armMuscleArea > 35 && armMuscleArea <= 55) return 'Above average';
    if (armMuscleArea > 55) return 'High muscle mass';
  }
  return 'Undetermined';
};

const classifyMuscleDiagnosis = (bmi, fatPercentage, muscleClassification) => {
  if (bmi > 30) return 'Obesity';
  if (fatPercentage > 25) return 'Excess fat';
  if (muscleClassification === 'Below average') return 'Low muscle mass';
  return 'Normal';
};

const classifyWaistCircumference = (waist, gender) => {
  const w = Number(waist);
  if (gender === 'male') {
    if (w < 94) return 'No risk';
    if (w <= 102) return 'Increased risk';
    return 'High risk';
  }
  if (gender === 'female') {
    if (w < 80) return 'No risk';
    if (w <= 88) return 'Increased risk';
    return 'High risk';
  }
  return 'Undetermined';
};

// utils/anthropometry/calculations.js
//Calcular IMC
const calculateBMI = (height, weight) => {
  if (!height || !weight) return NaN;
  return (weight / (height * height)).toFixed(2);
};
//Calcular Peso Teórico
const calculateTheoreticalWeight = (height, gender) => {
  const baseWeight = height - 100;
  let percentage = 0;

  if (gender === 'male') {
    if (height >= 140 && height <= 155) percentage = 0;
    else if (height > 155 && height <= 170) percentage = 5;
    else if (height > 170) percentage = 10;
  } else if (gender === 'female') {
    if (height >= 140 && height <= 150) percentage = 0;
    else if (height > 150 && height <= 165) percentage = 10;
    else if (height > 165) percentage = 15;
  }

  return baseWeight - (baseWeight * percentage / 100);
};

//Calcular Altura Estimada
const calculateEstimatedHeight = (age, kneeHeight, gender) => {
  if (gender === 'male') {
    return (64.19 - (0.04 * age) + (2.02 * kneeHeight)).toFixed(2);
  }
  if (gender === 'female') {
    return (84.88 - (0.24 * age) + (1.83 * kneeHeight)).toFixed(2);
  }
  return 'Undefined';
};


const hasRequiredSkinfolds = (equationCode, skinfolds) => {
  const required = {
    '1': ['triceps', 'subscapular', 'suprailiac'],
    '2': ['chest', 'abdominal', 'thigh', 'triceps', 'subscapular', 'suprailiac', 'axillary'],
    '3': ['triceps', 'biceps', 'subscapular', 'suprailiac'],
    '4': ['biceps', 'triceps', 'subscapular', 'suprailiac'],
  };

  const requiredKeys = required[equationCode] || [];

  return requiredKeys.every(key => {
    const value = Number(skinfolds[key]);
    return !isNaN(value) && value > 0;
  });
};

//Calcular BMR - Body 
const calculateBMR = (gender, theoreticalWeight, currentWeight, heightInMeters, age) => {
  const weight = age <= 10 ? currentWeight : theoreticalWeight;
  if (!weight || !heightInMeters || !age) return 0;

  let bmr = 0;
  if (gender === 'male') {
    bmr = 88.36 + (13.4 * weight) + (4.8 * heightInMeters * 100) - (5.7 * age);
  } else if (gender === 'female') {
    bmr = 447.6 + (9.2 * weight) + (3.1 * heightInMeters * 100) - (4.3 * age);
  }
  return bmr.toFixed(2);
};

const calculateTEE = (bmr, activityLevel) => {
  if (!bmr || !activityLevel) return 0;
  return (bmr * activityLevel).toFixed(2);
};

//Calcular Peso da Massa Gorda
const calculateFatMassWeight = (weight, bodyFatPercentage) => {
  return (weight * (bodyFatPercentage / 100)).toFixed(2);
};

//Calcular Massa Magra Corporal
const calculateLeanBodyMass = (weight, fatMassWeight) => {
  return (weight - fatMassWeight).toFixed(2);
};

//Calcular Tipo do peso magro
const calculateLeanWeightType = (leanMass, gender) => {
  const lean = Number(leanMass);
  if (isNaN(lean)) return 'Undefined';
  if (gender === 'male') return lean < 50 ? 'Low' : 'Normal';
  return lean < 40 ? 'Low' : 'Normal';
};

const calculateTotalBodyWater = (leanBodyMass) => {
  return (leanBodyMass * 0.73).toFixed(2);
};

const calculateArmMuscleCircumference = (ac, tsf) => {
  const pi = Math.PI;
  const acNumber = Number(ac);
  const tsfNumber = Number(tsf) / 10;
  if (acNumber <= 0 || tsfNumber <= 0) return 'N/A';
  const amc = acNumber - (pi * tsfNumber);
  return amc <= 0 ? 'Invalid value' : amc.toFixed(2);
};

const calculateArmMuscleArea = (ac, tsf) => {
  const pi = Math.PI;
  const acNumber = Number(ac);
  const tsfNumber = Number(tsf) / 10;
  if (!acNumber || !tsfNumber) return 'N/A';
  const amc = acNumber - (pi * tsfNumber);
  if (amc <= 0) return 'Invalid value';
  return ((amc * amc) / (4 * pi)).toFixed(2);
};

const calculateCorrectedArmMuscleArea = (ac, tsf, gender) => {
  const pi = Math.PI;
  const acNumber = Number(ac);
  const tsfNumber = Number(tsf) / 10;
  if (!acNumber || !tsfNumber) return 'N/A';
  const base = acNumber - (pi * tsfNumber);
  const correction = gender === 'male' ? 10 : 6.5;
  return ((base * base) / (4 * pi) - correction).toFixed(2);
};

const calculateArmArea = (ac) => {
  const pi = Math.PI;
  return ((pi * Math.pow(ac, 2)) / 4).toFixed(2);
};

const calculateArmFatArea = (aa, ama) => {
  return (aa - ama).toFixed(2);
};

// Peso Estimado Atual
const calculateEstimatedCurrentWeight = (estimatedHeight, bmiReference = 22) => {
  return (bmiReference * ((estimatedHeight / 100) ** 2)).toFixed(2);
};

// Relação Cintura-Quadril
const calculateWHR = (waistCircumference, hipCircumference) => {
  if (!waistCircumference || !hipCircumference) return null;
  return (waistCircumference / hipCircumference).toFixed(2);
};

// Massa Residual
const calculateResidualMass = (weight, fatMass, leanMass) => {
  const residual = weight - fatMass - leanMass;
  const fixed = Number(residual.toFixed(2));
  return fixed === -0 ? 0 : fixed;
};

// Excesso de Peso
const calculateWeightExcess = (currentWeight, idealWeight) => {
  const diff = currentWeight - idealWeight;
  return diff > 0 ? diff.toFixed(2) : '0.00';
};

// Déficit de Peso
const calculateWeightDeficit = (currentWeight, idealWeight) => {
  const diff = idealWeight - currentWeight;
  return diff > 0 ? diff.toFixed(2) : '0.00';
};

//Calcular CMB - Circunferência Muscular do Braço
const calculateCMB = (cb, triceps) => {
  const armCirc = Number(cb);
  const tricepsFold = Number(triceps);
  if (isNaN(armCirc) || isNaN(tricepsFold)) return undefined;

  const cmb = armCirc - (Math.PI * (tricepsFold / 10));
  return Number(cmb.toFixed(2)); // Retorna com 2 casas decimais
};

// Peso Ideal com IMC padrão 22
const calculateIdealWeight = (height, bmiReference = 22) => {
  if (!height) return null;
  return (bmiReference * ((height / 100) ** 2)).toFixed(2);
};

//Calculate AMB - Área Muscular do Braço
const calculateAMB = (cb, triceps) => {
  const cbVal = Number(cb);
  const tricepsVal = Number(triceps);
  if (isNaN(cbVal) || isNaN(tricepsVal)) return undefined;

  const cb2 = Math.pow(cbVal, 2);
  const dcCm = tricepsVal / 10;
  const amb = (cb2 / (4 * Math.PI)) - ((dcCm * cbVal) / (2 * Math.PI));
  return Number(amb.toFixed(2));
};

//Calculate AMBc - Área Muscular do Braço Corrigida
const calculateAMBc = (amb) => {
  const ambVal = Number(amb);
  if (isNaN(ambVal)) return undefined;

  const ambc = ambVal - (Math.PI * 10);
  return Number(ambc.toFixed(2));
};


// Peso da Massa Corporal
const calculateMuscleMassWeight = (leanBodyMass, totalBodyWater, residualMass) => {
  const lbm = Number(leanBodyMass);
  const tbw = Number(totalBodyWater);
  const rm = Number(residualMass);

  if (isNaN(lbm) || isNaN(tbw) || isNaN(rm)) return 0;

  const muscleMass = lbm - (tbw + rm);
  return muscleMass > 0 ? Number(muscleMass.toFixed(2)) : 0;
};



const classifyBray = (bmi) => {
  if (bmi < 16) return 'Severe underweight grade III';
  if (bmi <= 16.9) return 'Severe underweight grade II';
  if (bmi <= 18.4) return 'Underweight grade I';
  if (bmi <= 24.9) return 'Normal';
  if (bmi <= 29.9) return 'Overweight';
  if (bmi <= 34.9) return 'Obesity grade I';
  if (bmi <= 39.9) return 'Obesity grade II';
  return 'Obesity grade III';
};

const classifyBlackburn = (ptPercent) => {
  if (ptPercent >= 91) return 'Normal';
  if (ptPercent >= 80) return 'Mild depletion';
  if (ptPercent >= 70) return 'Moderate depletion';
  if (ptPercent < 70) return 'Severe depletion';
  return 'Undetermined';
};

const classifyBiotype = (height, gender) => {
  if (gender === 'male') {
    if (height <= 155) return 'Short-limbed';
    if (height <= 170) return 'Normal-limbed';
    return 'Long-limbed';
  }
  if (gender === 'female') {
    if (height <= 150) return 'Short-limbed';
    if (height <= 165) return 'Normal-limbed';
    return 'Long-limbed';
  }
  return 'Undetermined';
};

const classifyInternalFatPercentage = (percentage) => {
  return percentage > 25 ? 'High' : 'Normal';
};

const calculateMuscleDiagnosis = (bmi, fatPercentage, muscleClassification) => {
  if (bmi > 30) return 'Obesity';
  if (fatPercentage > 25) return 'Excess fat';
  if (muscleClassification === 'Below average') return 'Low muscle mass';
  return 'Normal';
};
const classifyActivityFactor = (physicalActivityLevel, gender) => {
  if (gender === 'male') {
    if (physicalActivityLevel === "light") return 1.55;    // Light physical activity
    if (physicalActivityLevel === "moderate") return 1.78; // Moderate physical activity
    if (physicalActivityLevel === "intense") return 2.10;  // Intense physical activity
  } else if (gender === 'female') {
    if (physicalActivityLevel === "light") return 1.56;    // Light physical activity
    if (physicalActivityLevel === "moderate") return 1.64; // Moderate physical activity
    if (physicalActivityLevel === "intense") return 1.82;  // Intense physical activity
  }

  console.error("Invalid activity factor or gender");
  return 0; // Returns 0 if unable to classify
};

// Function to Classify Activity Frequency with useCallback - Values Based on CDC (Centers for Disease Control and Prevention) and ACSM (American College of Sports Medicine):
const classifyActivityLevel = (frequencyOfActivity) => {
  if (frequencyOfActivity === "unable") return 1.2;      // Sedentary (little or no physical activity)
  if (frequencyOfActivity === "sedentary") return 1.375; // Light (light exercise or activity 1-3 days per week)
  if (frequencyOfActivity === "occasional") return 1.55; // Moderate (moderate exercise 3-5 days per week)
  if (frequencyOfActivity === "frequent") return 1.725;  // Active (intense exercise 6-7 days per week)
  if (frequencyOfActivity === "regular") return 1.9;     // Very Active (very intense exercises or heavy physical activity)

  console.error("Invalid activity frequency");
  return 0; // Returns 0 if unable to classify
};

const classifyLeanBodyMass = (leanMass, gender) => {
  if (gender === 'male') return leanMass < 50 ? 'Low' : 'Normal';
  return leanMass < 40 ? 'Low' : 'Normal';
};

const classifyBernadinelli = (index) => {
  if (index >= 1.9) return 'Long-limbed';       // Longilíneo
  if (index >= 1.7) return 'Normal';            // Mesolíneo
  return 'Short-limbed';                        // Brevilíneo
};


const calculateDPP = (dum) => {
  if (!dum) return null;
  const dataDUM = new Date(dum);
  const dpp = new Date(dataDUM.setDate(dataDUM.getDate() + 280)); // 40 semanas
  return format(dpp, 'dd/MM/yyyy');
};

const formatDateToISO = (dateStr) => {
  if (!dateStr || typeof dateStr !== 'string') return null;
  const [day, month, year] = dateStr.split('/');
  if (!day || !month || !year) return null;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};



module.exports = {
  calculateBMI,
  calculateTheoreticalWeight,
  calculateEstimatedHeight,
  calculateBMR,
  calculateTEE,
  calculateFatMassWeight,
  calculateLeanWeightType,
  calculateLeanBodyMass,
  calculateTotalBodyWater,
  calculateArmMuscleCircumference,
  calculateArmMuscleArea,
  calculateCorrectedArmMuscleArea,
  calculateArmArea,
  calculateArmFatArea,
  calculateEstimatedCurrentWeight,
  calculateWHR,
  calculateResidualMass,
  calculateWeightExcess,
  calculateWeightDeficit,
  calculateIdealWeight,
  calculateCMB,
  calculateAMB,
  calculateAMBc,
  calculateMuscleMassWeight,
  hasRequiredSkinfolds,
  activityFactorCodeMap,
  selectOptions,
  classifyBray,
  classifyBlackburn,
  classifyBiotype,
  classifyInternalFatPercentage,
  calculateMuscleDiagnosis,
  classifyActivityFactor,
  classifyActivityLevel,
  classifyLeanBodyMass,
  classifyBernadinelli,
  formatDateToISO,
  classifyBMI,

};

